module.exports = __webpack_public_path__ + "static/media/company.fffff5a1.png";